export default "__VITE_ASSET__cXpccvJl__"